import { CredentialResponse, GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import { useLayoutEffect, useRef, useState } from "react";

import { cn } from "@/app/lib/utils";

const GOOGLE_MAX_BUTTON_WIDTH = 400;

interface GoogleSignInButtonProps {
	onSuccess: (googleUser: CredentialResponse) => void;
	onError: () => void;
	oneTap?: boolean;
	autoSelect?: boolean;
	className?: string;
}

function GoogleSignInButton({
	onSuccess,
	onError,
	oneTap = false,
	autoSelect = false,
	className,
}: GoogleSignInButtonProps) {
	const containerRef = useRef<HTMLDivElement>(null);
	const [containerWidth, setContainerWidth] = useState(0);

	useLayoutEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		const measure = () => setContainerWidth(container.offsetWidth);
		measure();

		const observer = new ResizeObserver(measure);
		observer.observe(container);
		return () => observer.disconnect();
	}, []);

	useGoogleOneTapLogin({ onSuccess, onError, auto_select: autoSelect, disabled: !oneTap });

	const renderedWidth = containerWidth > 0 ? `${Math.min(containerWidth, GOOGLE_MAX_BUTTON_WIDTH)}px` : undefined;

	return (
		<div ref={containerRef} className={cn("flex items-center justify-center", className)}>
			<GoogleLogin
				key={renderedWidth ?? "unmeasured"}
				onSuccess={onSuccess}
				onError={onError}
				size="large"
				width={renderedWidth}
				text="continue_with"
			/>
		</div>
	);
}

export default GoogleSignInButton;
